export type CallBackFn = (...args: any[]) => any;

export const debounce = (callBackFn: CallBackFn, delay: number) => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return function (...args: any[]) {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      timer = null;
      callBackFn(...args); // Pass arguments to the callback function
    }, delay);
  };
};
